export enum FilterInteractionMode {
  // When the user is tweaking the filters
  EXPLORING,
  // When the user has selected a quick filter (read-only)
  VIEWING,
  // When the user is editing a quick filter
  EDITING,
}
